import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';
import getQualifications from './getQualifications';

const actions = createActions({
  USER: {
    REMOVE_QUALIFICATION: (id) => ({ id }),
    API: {
      REMOVE_QUALIFICATION: apiResourceActionCreator('qualifications')
    }
  }
})

export const apiAction = (authToken, qualificationId) => commonApiActions.authenticated.delete(`${USER_RESOURCE_ENDPOINT(RESOURCES.Qualification)}/${qualificationId}`, authToken, actions.user.api.removeQualification)

export function* removeQualification(action) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken, action.payload.id));

    const result = yield apiActionResult(actions.user.api.removeQualification);
    if (result.success) {
      yield put(getQualifications.action.user.getQualifications());
      yield put(push({ pathname: routes.app.professionalProfile.root }))
    }
  }
}

const configuration = {
  name: 'removeQualification',
  action: actions,
  sagas: removeQualification,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      isUpdating: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/removeQualification.js